import { render, staticRenderFns } from "./SfReMaster.vue?vue&type=template&id=6efa473a&"
import script from "./SfReMaster.vue?vue&type=script&lang=ts&"
export * from "./SfReMaster.vue?vue&type=script&lang=ts&"
import style0 from "./SfReMaster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports